export default __webpack_public_path__ + "static/media/sydney.797c13ad.svg";